export const ROUTES = {
  APP_ROOT: '/',
  LOGIN: '/profile',
  DASHBOARD: '/dashboard',
  CHARACTER: '/character/:id',
  FAVOURITES: '/favourites',
};
